// webpack ProvidePlugin({ Buffer }) injected a global Buffer; restore it for Vite.
// Must be imported before any module that may touch Buffer at evaluation time.
import { Buffer } from 'buffer';

globalThis.Buffer = globalThis.Buffer || Buffer;
